import React, { useState } from 'react';
import { Menu, MenuItem } from '@material-ui/core';
import { BoxV2 as Box } from 'portal-commons';
import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface MenuItemConfig<T> {
  label: string;
  onClick: (data: T) => Promise<void> | void;
  disabled?: boolean;
  hidden?: boolean;
  [key: string]: any;
}

interface MoreButtonProps<T> {
  data: T;
  items: MenuItemConfig<T>[];
  menuClass?: string;
  disabled?: boolean;
}

const MoreButton = <T,>({
  data,
  items,
  menuClass,
  disabled = false,
  ...restProps
}: MoreButtonProps<T>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLDivElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        as="button"
        onClick={(event) => !disabled && handleClick(event)}
        sx={{
          cursor: `${disabled ? 'not-allowed' : 'pointer'}`,
          padding: '3px',
          border: 'none',
          background: 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
        {...restProps}
      >
        <FontAwesomeIcon
          icon={faEllipsisVertical}
          style={{
            cursor: `${disabled ? 'not-allowed' : 'pointer'}`,
            color: `${disabled ? '#CCCCCC' : '#D41C54'}`,
            width: 20,
            height: 20,
          }}
        />
      </Box>
      <Menu
        className={menuClass}
        disableAutoFocusItem
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {items
          .filter(({ hidden }) => !hidden)
          .map((item) => {
            const { label, onClick, ...rest } = item;
            return (
              <MenuItem
                key={label}
                onClick={() => {
                  onClick?.(data);
                  handleClose();
                }}
                {...rest}
              >
                {label}
              </MenuItem>
            );
          })}
      </Menu>
    </>
  );
};

export default MoreButton;
